<template>
  <div>
    <div class="content-title">
      <div>מרכזים את הכל</div>
      <div>במקום אחד!</div>
    </div>
    <div class="content-text">
      <div>
        בכל כניסה לתזרים שלך אפשר לראות את כל הנתונים מכל חשבונות הבנק וכרטיסי האשראי.
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'MiddlePeriodContent',
};
</script>

<style lang="scss" scoped>

  .content-text {
    line-height: 1.5;
  }

  .content-title {
    margin-bottom: 16px;
    font-family: GretaSans,serif;
    font-size: 24px;
    line-height: 24px;
  }

</style>
